import React, {useEffect, useMemo, useRef, useState} from 'react';
import {useHistory, useLocation, useParams} from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import {useDropzone} from "react-dropzone";
import axios from 'axios';
import Cookies from 'js-cookie';
import actions from 'actions';
import * as constants from 'constants/index.js';
import {validateForm} from 'constants/index.js';
import CardsHeader from 'layouts/Headers/CardsHeader.js';

import InputCustom from 'views/pages/components/InputCustom';
import {ArraySelect, InputAddressSelect, InputArraySelect, InputKeySelect} from 'views/pages/components/InputSelect';
import TableCustom from 'views/pages/components/TableCustom';

import {
    Card,
    CardBody,
    CardHeader,
    CardSubtitle,
    CardText,
    CardTitle,
    Col,
    Container,
    FormGroup,
    Input,
    Modal,
    Row,
} from "reactstrap";
import {ButtonContainer, LoaderContainer, override} from "@pages/reusable-components/styled-components";
import {ClipLoader} from "react-spinners";
import usePrevious from "../../../../hooks/useprevious";
import CustomTabs from "@pages/components/CustomTabs";
import DebounceInput from "@pages/components/DebounceInput";
import IcoMoon from "react-icomoon";
import IconSet from "@assets/selection.json";
import EmailsTable from "@pages/components/Table/EmailsTable";
import CalendarFilter from "@pages/components/CalendarFilter";
import CustomSearch from "@pages/components/CustomSearch";
import EmailsTab from "@pages/customers/customer/emails/emails";
import NotesListComponent from "@pages/components/NotesListComponent";
import CustomDamageDropDown from "@pages/components/JobDetailsComponents/CustomDropDown";
import notify from "@utils/notify";
import Personal from "@pages/customers/customer/editTabs/Personal";
import Address from "@pages/customers/customer/editTabs/Address";
import Finance from "@pages/customers/customer/editTabs/Finance";
import Company from "@pages/customers/customer/editTabs/Company";

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "20px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#eeeeee",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  color: "#bdbdbd",
  outline: "none",
  transition: "border .24s ease-in-out"
};

const activeStyle = {
  borderColor: "#2196f3"
};

const acceptStyle = {
  borderColor: "#00e676"
};

const rejectStyle = {
  borderColor: "#ff1744"
};

export default function CustomerEdit() {
  const { id } = useParams();
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { activeMenu } = useSelector((state) => state.getState);
  const profileData = useSelector((state) => state.getState).profileData;

  const prevTab = usePrevious(activeMenu)
  const [tab, setTab] = useState('');
  const [isNotValid, setIsNotValid] = useState(false);
  const [activeTab, setActiveTab] = useState('Notes');
  const [address, setAddress] = useState(null);
  const [allTabs] = useState(['Notes','Personal', 'Address', 'Finance', 'Company', 'Emails'])
  const [token, setToken] = useState('');
  const [businessTypes, setBusinessTypes] = useState([]);
  const [lookupAddresses, setLookupAddresses] = useState([]);
  const [emailsNextPageToken, setEmailsNextPageToken] = useState(null);
  const [emails, setEmails] = useState([]);
  const [fullMailData, setFullMailData] = useState(null);
  const [selectedGmailUserIndex, setSelectedGmailUserIndex] = useState(0);
  const [emailKeys] = useState([
    {
      key: 'From',
      label: 'From'
    },
    {
      key: 'Subject',
      label: 'Subject'
    },
    {
      key: 'Date',
      label: 'Received'
    }
  ]);

  const options = [
    {
      label: 'Read',
      value: 'read',
    },
    {
      label: 'Unread',
      value: 'unread',
    },
    {
      label: 'Starred',
      value: 'starred',
    },
    {
      label: 'Snoozed',
      value: 'snoozed',
    },
  ]

  const [companyTypes, setCompanyTypes] = useState([]);
  const [counties, setCounties] = useState([]);
  const [titles, setTitles] = useState('');
  const [showBackButton, setShowBackButton] = useState(false)
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(false)
  const [documents, setDocuments] = useState([]);
  const [availableDocumentsUploadTypes, setAvailableDocumentsUploadTypes] = useState('');
  const [fileLists, setFileLists] = useState([]);
  const [fileTypes, setFileTypes] = useState([]);
  const [users, setUsers] = useState([]);

  const [confirmShow, setConfirmShow] = useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState('');

  const [filter, setFilter] = useState('');
  const [dateFilter, setDateFilter] = useState(null);

  const onDrop = (acceptedFiles) => {
    let newFileTypes = fileTypes;
    acceptedFiles.forEach((item) => {
      newFileTypes[item.name] = "photo_id";
    })
    setFileTypes(newFileTypes);
    setFileLists(prev => [...prev, ...acceptedFiles]);
  }

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({ onDrop });

  const [errors, setErrors] = useState('');

  const [customer, setCustomer] = useState('');
  const [managers, setManagers] = useState([]);
  const [paymentManagers, setPaymentManagers] = useState([]);
  const [accountManager, setAccountManager] = useState(null);
  const [paymentManager, setPaymentManager] = useState(null);

  const [loadingDocuments, setLoadingDocuments] = useState(true);

  const [loading, setLoading] = useState(true);


  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {})
    }),
    [isDragActive, isDragReject, isDragAccept]
  );
  useEffect(() => {
    const grs_token = Cookies.get('grs_token')
    axios({
      method: 'GET',
      url: `${constants.API_CORE_URL}/account-managers`,
      headers: {
        Authorization: `Bearer ${grs_token}`,
      },
    }).then((res) => {
      const data = res.data.data;
      setManagers(data.accountManagers);
      setPaymentManagers(data.paymentManagers);
    }).catch((error) => {
      notify.warning('warning', 'Warning', error.response.data.message ? error.response.data.message : error.response.statusText)

    })
  }, [])
  useEffect(() => {
    if (prevTab) {
      setLoading(true);
      const grs_token = Cookies.get('grs_token')
      setToken(grs_token)

      const source = axios.CancelToken.source()

      const fetchData = async () => {
        try {
          const response = await axios({
            method: 'GET',
            url: `${constants.API_CORE_URL}/customer/${id}`,
            headers: {
              Authorization: `Bearer ${grs_token}`,
            },
            cancelToken: source.token,
          })
          const data = response.data
          let tempCustomer = {
            ...data.data,
            dob: data.data.dob ? constants.formatDate(data.data.dob) : ''
          }
          const postalCode = await axios({
            method: 'GET',
            url: `${constants.UK_VEHICLE_DATA_API_URL}/PostcodeLookup?v=2&api_nullitems=1&auth_apikey=${constants.UK_VEHICLE_DATA_API_KEY}&key_POSTCODE=${tempCustomer.postal_code}`,
          })
          if (postalCode.status === 200) {
            const data = postalCode.data
            if (data.Response) {
              if (data.Response.StatusCode === 'Success') {
                const addressList = data.Response.DataItems.AddressDetails.AddressList
                if (addressList.length === 1) {
                  setSelectedAddress(addressList[0]);
                } else if (addressList.length > 1) {
                  setLookupAddresses(addressList);
                }
              } else {
                setErrors({
                  ...errors,
                  postal_code: data.Response.StatusMessage
                })
                setLookupAddresses([])
              }
            }
          }
          setCustomer(tempCustomer);
          setAccountManager(tempCustomer?.account_manager_id)
          setPaymentManager(tempCustomer?.payment_manager_id)
          const companyTypesResponse = await axios({
            method: 'GET',
            url: `${constants.API_CORE_URL}/company-type`,
            headers: {
              Authorization: `Bearer ${grs_token}`,
            },
            cancelToken: source.token,
          })
          const countyResponse = await axios({
            method: 'GET',
            url: `${constants.API_CORE_URL}/county`,
            headers: {
              Authorization: `Bearer ${grs_token}`,
            },
            cancelToken: source.token,
          })
          const businessTypesResponse = await axios({
            method: 'GET',
            url: `${constants.API_CORE_URL}/business-activity`,
            headers: {
              Authorization: `Bearer ${grs_token}`,
            },
            cancelToken: source.token,
          })
          setBusinessTypes(businessTypesResponse.data.data)
          setCompanyTypes(companyTypesResponse.data.data)
          setCounties(countyResponse.data.data)
          setTitles(constants.titles);

          dispatch(actions.getNotifications(grs_token));
          setLoading(false);
        } catch (error) {
          setLoading(false);
          if (axios.isCancel(error)) {
          } else {
            notify.warning(error.response.data.message ? error.response.data.message : error.response.statusText)
          }
        }
      }
      const tabs = [
        {
          value: 'info',
          key: 'Customer Info',
        },
        {
          value: 'documents',
          key: 'Documents Management',
        },
        {
          value: 'tasks',
          key: 'Tasks',
          action: true
        },
        {
          value: 'notes',
          key: 'Notes',
          action: true
        },
        {
          value: 'emails',
          key: 'Emails',
          action: true
        },
      ]
      dispatch(actions.setMenusList(tabs))
      dispatch(actions.setMenuName('Customers'))

      localStorage.setItem('menuName', 'Customers')
      fetchData()

      if (location.state && location.state.filter) {
        setFilter(location.state.filter);
      }

      return () => {
        source.cancel()
      }
    }
  }, [prevTab])

  useEffect(() => {
    setShowBackButton(!!tab)
    if (tab === 'documents') {
      axios({
        method: 'GET',
        url: constants.API_URL + '/customer/' + id + '/documents',
        headers: {
          Authorization: 'Bearer ' + token
        }
      })
        .then(response => {
          if (response.status === 200) {
            let data = response.data;
            setDocuments(data.data.documents);
            setFileLists([]);
            setFileTypes([]);
            setAvailableDocumentsUploadTypes(data.data.availableDocumentsUploadTypes);
            setTimeout(() => {
              setLoadingDocuments(false);
            }, 1000);
          }
        })
        .catch(error => {
          setLoadingDocuments(false);
          notify.warning(error.response.statusText);
        })
    } else if (tab === 'emails' && customer.email) {
      axios({
        method: 'GET',
        url: constants.API_URL + '/get-gmail-users',
        headers: {
          Authorization: 'Bearer ' + token
        },

      })
        .then(response => {
          if (response.status === 200) {
            const tempUsers = response.data.data
            setUsers(tempUsers)
            fetchCustomerEmails(0, null, {}, tempUsers)
          }
        })
        .catch(() => {
          notify.warning('Something went wrong please try again later')
          setLoadingDocuments(false);
        })

    }
  }, [tab, customer.email])

  const getGmailOtherPages = async () => {
    await fetchCustomerEmails(selectedGmailUserIndex, emailsNextPageToken, dateFilter)
  }
  const fetchCustomerEmails = async (index = 0, nextToken = null, localFilter = {}, localUsers = []) => {
    await setLoadingDocuments(true);
    const source = await axios.CancelToken.source()
    axios({
      method: 'GET',
      url: constants.API_URL + '/get-customer-gmail-data',
      params: {
        email: customer.email,
        userEmail: users.length ? users[index] : localUsers[index],
        nextPageToken: nextToken,
        ...localFilter,
      },
      headers: {
        Authorization: 'Bearer ' + token
      },
      cancelToken: source.token,

    })
      .then(response => {
        if (response.status === 200) {
          setEmailsNextPageToken(response.data.data.nextPageToken);
          setEmails(response.data.data.emails);
          setLoadingDocuments(false);
        }
      })
      .catch(() => {
        notify.warning('Something went wrong please try again later')
        setLoadingDocuments(false);
      })
  }
  const selectGmailUser = async (index) => {
    await setSelectedGmailUserIndex(index)
    await setFullMailData(null)
    await setDateFilter(null)
    await fetchCustomerEmails(index)
  }
  const getMailsDetails = (id) => {
    setLoadingDocuments(true)
    axios({
      method: 'GET',
      url: constants.API_URL + `/get-gmail-details/${id}`,
      params: {
        email: users[selectedGmailUserIndex],
      },
      headers: {
        Authorization: 'Bearer ' + token
      }
    })
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data
          let tempData = {
            subject: '',
            from: '',
            text: ''
          }
          data.payload.headers.forEach(item => {
            if (item.name === 'Subject') {
              tempData.subject = item.value
            } else if (item.name === 'From') {
              tempData.from = item.value
            }
          })

          let parser = new DOMParser();
          let doc = parser.parseFromString(data.snippet, "text/html");
          tempData.text = doc.documentElement.textContent;

          setFullMailData(tempData)
          setLoadingDocuments(false)
        }
      })
      .catch(() => {
        setLoadingDocuments(false)
      })
  }

  const filterSearch = async () => {
    await fetchCustomerEmails(selectedGmailUserIndex, null, dateFilter)
  }

  useEffect(() => {
    const enter = (ev: KeyboardEvent) => {
      if (!loadingDocuments && (ev.key === "Enter" || ev.key === "Return")) {
        filterSearch();
      }
    };
    window.addEventListener("keyup", enter, false);
    return () => {
      window.removeEventListener("keyup", enter, false);
    };
  }, [dateFilter, selectedGmailUserIndex, loadingDocuments]);

  const sendPasswordLink = () => {
    axios({
      method: 'GET',
      url: constants.API_URL + '/customer/get-link/' + id,
      headers: {
        Authorization: 'Bearer ' + token
      },
      data: {
        email: customer.company_name,
        id: customer.id,
      }
    })
  }
  const updateCustomer = (update = {}) => {
    const updatedCustomer = {...customer,...update}
    setCustomer({...updatedCustomer})

    const required = ['full_name', 'email', 'mobile_number', 'driver_license_number','address']
    if (validateForm(required, updatedCustomer))
    {
      axios({
        method: 'PUT',
        url: constants.API_URL + '/customer/' + id,
        headers: {
          Authorization: 'Bearer ' + token
        },
        data: {
          ...updatedCustomer,
          business_activity_id: updatedCustomer.business_activity_id ? updatedCustomer.business_activity_id : updatedCustomer.company.business_activity_id,
          company_type_id: updatedCustomer.company_type_id ? updatedCustomer.company_type_id : updatedCustomer.company.company_type_id,
          company_name: updatedCustomer.company_name ? updatedCustomer.company_name : updatedCustomer.company.name,
          business_address: updatedCustomer.business_address ? updatedCustomer.business_address : updatedCustomer.company.address,
          business_phone_number: updatedCustomer.business_phone_number ? updatedCustomer.business_phone_number : updatedCustomer.company.phone_number,
          postal_code: updatedCustomer.postal_code ? updatedCustomer.postal_code : undefined
        }
      })
          .then(response => {
            if (response.status === 200) {
              notify.success('Successfully updated!');
            }
          })
          .catch(error => {
            setErrors('');
            if (error.response.status === 422) {
              let errors = error.response.data.errors;
              setErrors(errors);
            }
            notify.warning(error.response.statusText);
          })
    } else {
      notify.warning('Please fill all required fields')
    }
  }

  const goList = () => {
    dispatch(actions.setMenusList([]))
    dispatch(actions.setMenuName(null))
    dispatch(actions.setActiveMenu(null))
    history.push({
      pathname: '/admin/customer',
      state: {
        filter: filter
      }
    });
  }
  const setSendType = (e, index) => {
    let newFileTypes = fileTypes;
    let key = fileLists[index].name;
    newFileTypes[key] = e.target.value;
    setFileTypes(newFileTypes);
  };

  const uploadDocument = () => {
    let formData = new FormData();
    for (let index = 0; index < fileLists.length; index++) {
      const element = fileLists[index];
      formData.append(`file[${index}]`, element);
    }
    Object.keys(fileTypes).forEach(key => {
      formData.append(`type[${key}]`, fileTypes[key]);
    })

    axios({
      method: 'POST',
      url: constants.API_URL + '/customer/' + id + '/documents',
      headers: {
        Authorization: 'Bearer ' + token
      },
      data: formData
    })
      .then(response => {
        if (response.status === 200) {
          let data = response.data;
          console.log('response data :: ', data);
          setDocuments(data.data);
          setFileLists([]);
          setFileTypes([]);
          notify.success(data.message);
        }
      })
      .catch(error => {
        setErrors('');
        console.error('error :: ', error);
        if (error.response && error.response.status === 422) {
          let errors = error.response.data.errors;
          setErrors(errors);
        }
        notify.warning(error.response && error.response.statusText ? error.response.statusText : 'Error occur.');
      })
  }

  const deleteDocument = () => {
    axios({
      method: 'GET',
      url: constants.API_URL + '/customer/' + id + '/remove/' + selectedDocumentId,
      headers: {
        Authorization: 'Bearer ' + token
      }
    })
      .then(response => {
        setConfirmShow(false);
        if (response.status === 200) {
          let data = response.data;
          console.log('response data :: ', data);
          setDocuments(data.data);
          setSelectedDocumentId('');
          setFileLists([]);
          setFileTypes([]);
          notify.success(data.message);
        }
      })
      .catch(error => {
        setConfirmShow(false);
        console.error('error :: ', error);
        notify.warning(error.response && error.response.statusText ? error.response.statusText : 'Error occur.');
      })
  }

  const viewDocument = (row) => {
    axios({
      method: 'GET',
      url: constants.API_URL + '/customer/' + id + '/view/' + row.id,
      headers: {
        Authorization: 'Bearer ' + token
      },
      responseType: 'blob'
    })
      .then(response => {
        if (response.status === 200) {
          let data = response.data;
          const disposition = response.request.getResponseHeader('Content-Disposition');
          let fileName = "";
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            fileName = matches[1].replace(/['"]/g, '');
          }
          const blob = new Blob([data])
          const downloadUrl = URL.createObjectURL(blob)
          let a = document.createElement("a");
          a.href = downloadUrl;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
        }
      })
      .catch(error => {
        console.error('error :: ', error);
        notify.warning(error.response && error.response.statusText ? error.response.statusText : 'Error occur.');
      })
  }

  const goSub = (subject) => {
    switch (subject) {
      case 'tasks':
        history.push({
          pathname: '/admin/customer/' + id + '/tasks',
          state: {
            filter: filter
          }
        });
        break;

      case 'notes':
        history.push({
          pathname: '/admin/customer/' + id + '/notes',
          state: {
            filter: filter
          }
        });
        break;

      default:
        break;
    }
  }

  const setSelectedAddress = (address) => {
    setAddress(address)
    const a = address.FormattedAddressLines
    const addressParts = address.ComponentParts;
    let summaryAddress = address.SummaryAddress;

    if (a) {
      if (!summaryAddress) {
        summaryAddress = `${a.Street ? a.Street : ''}${a.Premises ? `, ${a.Premises}` : ''}${a.PostTown ? `, ${a.PostTown}` : ''}${a.Organisation ? `, ${a.Organisation}` : ''}${a.Locality ? `, ${a.Locality}` : ''}${a.County ? `, ${a.County}` : ''}`
      }
      setCustomer({
        ...customer,
        address: summaryAddress,
        street: addressParts.Street,
        city: a.PostTown,
        building: `${addressParts.BuildingName ? addressParts.BuildingName + (addressParts.BuildingNumber ? ',' : '') : ''}${addressParts.BuildingNumber ? ' ' + addressParts.BuildingNumber : ''}${addressParts.SubBuildingName ? ', ' + addressParts.SubBuildingName : ''}`
      })
    }
  }

  const getAddressByPostcode = (postcode) => {
    axios({
      method: 'GET',
      url: `${constants.UK_VEHICLE_DATA_API_URL}/PostcodeLookup?v=2&api_nullitems=1&auth_apikey=${constants.UK_VEHICLE_DATA_API_KEY}&key_POSTCODE=${postcode}`,
    })
      .then(response => {
        const data = response.data

        if (data.Response) {

          if (data.Response.StatusCode === 'Success') {

            const addressList = data.Response.DataItems.AddressDetails.AddressList

            if (addressList.length === 1) {
              setCustomer({
                ...customer,
                postal_code: postcode
              });

              setErrors({
                ...errors,
                postal_code: ''
              })

              setSelectedAddress(addressList[0]);
            } else if (addressList.length > 1) {
              setCustomer({
                ...customer,
                postal_code: postcode
              })

              setErrors({
                ...errors,
                postal_code: ''
              })

              setLookupAddresses(addressList);
            }
          } else {
            setErrors({
              ...errors,
              postal_code: data.Response.StatusMessage
            })
            setLookupAddresses([])
            setCustomer({
              ...customer,
              postal_code: postcode,
              address: ''
            })
          }
        }
      })
      .catch(error => {
        console.error('error :: ', error)
      })
  }
  useEffect(() => {
    if (activeMenu) {
      if (activeMenu === 'tasks' || activeMenu === 'notes') {
        goSub(activeMenu)
      }
      setTab(activeMenu)
    } else {
      dispatch(actions.setActiveMenu('info'))
      setTab('info')
    }

  }, [activeMenu])
  const saveAccountManager = () => {
    setSaveButtonDisabled(true)
    axios({
      method: 'post',
      url: `${constants.API_CORE_URL}/assign-account-manager`,
      data: {
        'customerId': customer.id,
        'managerId': accountManager,
        'paymentManagerId': paymentManager,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },

    }).then(() => {
      setCustomer({
        ...customer,
        account_manager_id: accountManager,
        payment_manager_id: paymentManager,
      })
      setSaveButtonDisabled(false)
    }).catch((error) => {
      console.log('error', error)
      setSaveButtonDisabled(false)
    })
  }
  return (
    loading ?
      <LoaderContainer>
        <ClipLoader
          css={override}
          size={40}
          color={`#7B61E4`}
          loading={loading}
        />
      </LoaderContainer> :
      <>
        <CardsHeader name="Customers" parentName="Customer Management" showBackButton={showBackButton} backButtonText={'Back to Customers'} redirect={goList} currentName="Edit customer" />

        <Container className="mt--5 admin-main-body" fluid >
          <Row>
            <Col xl="12">
              <Card>
                {tab === 'info' && <CardBody>
                  <Row>
                    <Col sm={12} lg={12}>
                      <CustomTabs tabs={allTabs} activeTab={activeTab} setActiveTab={(e) => {
                        setActiveTab(e)
                      }} />
                    </Col>
                  </Row>
                  {
                      activeTab !== 'Notes' &&
                      <Row className='mt-2'>
                        <Col lg={3} sm={12}>
                          <CustomDamageDropDown
                              emptyTitle={'Account Manager'}
                              data={[{ name: '-'}, ...managers]}
                              labelKey={'name'}
                              valueKey={'id'}
                              selectedTitle={parseInt(accountManager)}
                              handleChange={(e)=>{
                                setAccountManager(e)
                              }}
                          />
                        </Col>

                        <Col sm={12} lg={3}>
                          <CustomDamageDropDown
                              emptyTitle={'Payment Manager'}
                              data={[{ name: '-'}, ...paymentManagers]}
                              labelKey={'name'}
                              valueKey={'id'}
                              selectedTitle={parseInt(paymentManager)}
                              handleChange={(e)=>{
                                setPaymentManager(e)
                              }}
                          />

                        </Col>
                        <Col lg={2}>
                          <ButtonContainer disabled={saveButtonDisabled} onClick={saveAccountManager}>
                            Save
                          </ButtonContainer>
                        </Col>
                      </Row>
                  }

                  {
                    activeTab === 'Personal' &&
                      <Personal onSave={updateCustomer} goList={goList} errors={errors} initialCustomer={customer} sendPasswordLink={sendPasswordLink} titles={titles}/>
                  }
                  {activeTab === 'Address' &&
                   <Address getAddressByPostcode={getAddressByPostcode}
                            initialCustomer={customer}
                            setSelectedAddress={setSelectedAddress}
                            errors={errors}
                            onSave={updateCustomer}
                            address={address}
                            counties={counties}
                            lookupAddresses={lookupAddresses}
                   />
                  }
                  {activeTab === 'Finance' &&
                      <Finance onSave={updateCustomer} initialCustomer={customer} goList={goList}/>
                  }
                  {activeTab === 'Company' &&
                      <Company errors={errors} companyTypes={companyTypes} businessTypes={businessTypes} onSave={updateCustomer} initialCustomer={customer} goList={goList}/>
                  }
                  {
                    activeTab === 'Notes' &&
                      <NotesListComponent
                          type={'debt'}
                          userId={profileData.id}
                          customerId={customer.id}
                          dealId={customer?.deals[0]?.id || 'null'}
                      />
                  }
                  {
                    activeTab === 'Emails' &&
                    <EmailsTab
                      customerId={customer.id}
                    />
                  }
                </CardBody>}
                {tab === 'documents' && <CardBody>
                  <div className="container">
                    <div {...getRootProps({ style })}>
                      <input {...getInputProps()} />
                      <p>Select or drop the documents, then match each of them to the right type</p>
                    </div>
                    <aside>
                      {fileLists.map((item, index) => {
                        return (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              borderBottom: '1px solid #CCC',
                              alignItems: 'center',
                              padding: 20,
                            }}
                            key={index}
                          >
                            <Col md={3}>
                              <span>{item.name}</span>
                            </Col>
                            <Col md={3}>
                              <span>{`${item.size} bytes`}</span>
                            </Col>
                            <Col md={2}>
                              {`Document type`}
                            </Col>
                            <Col md={4}>
                              <Input
                                type='select'
                                id={`select_${index}`}
                                onChange={(e) => setSendType(e, index)}
                              >
                                {Object.keys(availableDocumentsUploadTypes).map((key) => {
                                  return (
                                    <option value={key} key={key}>
                                      {availableDocumentsUploadTypes[key]}
                                    </option>
                                  );
                                })}
                              </Input>
                            </Col>
                          </div>
                        )
                      })}
                    </aside>
                  </div>
                   <div className="d-flex flex-row justify-content-end mt-3">
                    <ButtonContainer onClick={() => goList(true)}>Cancel</ButtonContainer>
                    <ButtonContainer reverse onClick={() => uploadDocument()}>Save</ButtonContainer>
                  </div>
                  <TableCustom
                    loading={loadingDocuments}
                    items={documents}
                    tableHeaderStyle={'header-text'}
                    keyField={`id`}
                    searchField={true}
                    columns={[
                      {
                        dataField: "document_name",
                        text: "Name",
                        sort: true
                      },
                      {
                        dataField: "document_type",
                        text: "Type",
                        sort: true,
                        formatter: (rowContent, row) => {
                          return availableDocumentsUploadTypes[row.category];
                        }
                      },
                      {
                        dataField: "",
                        text: "Action",
                        formatter: (rowContent, row) => {
                          return (
                            <>
                              <IcoMoon
                                className={'cursor-pointer'}
                                iconSet={IconSet}
                                icon={'delete_outline'}
                                size={24}
                                onClick={() => {
                                  setConfirmShow(true);
                                  setSelectedDocumentId(row.id);
                                }}
                              />
                              <IcoMoon
                                className={'cursor-pointer'}
                                iconSet={IconSet}
                                icon={'visibility'}
                                size={24}
                                onClick={() => viewDocument(row)}
                              />
                            </>
                          )
                        }
                      }
                    ]}
                  />
                  <Modal
                    isOpen={confirmShow}
                    toggle={() => setConfirmShow(false)}
                    className="modal-dialog-centered modal-secondary"
                  >
                    <div className="modal-body">
                      {`Are you sure you want to delete this document?`}
                    </div>
                    <div className="modal-footer">
                      <ButtonContainer
                        reverse
                        onClick={() => deleteDocument()}
                      >
                        {`Delete`}
                      </ButtonContainer>
                      <ButtonContainer
                        onClick={() => setConfirmShow(false)}
                      >
                        Cancel
                      </ButtonContainer>
                    </div>
                  </Modal>
                </CardBody>}
                {tab === 'emails' &&
                  <Card>

                    <CardHeader>
                      <Row>
                        <Col lg={2} sm={10} className={'p-2'}>
                          <h1 className="mb-0">Emails</h1>
                        </Col>
                        <Col lg={3} sm={10} className={'p-2'} >
                          <CustomSearch
                            border={'1px solid #ccc'}
                            borderRadius={'8px'}
                            withoutDaley={true}
                            onChange={(e) => {
                              setDateFilter({ ...dateFilter, search: e.target.value })
                            }
                            }
                          />
                        </Col>
                        <Col lg={2} sm={10} className={'p-2'}>
                          <InputArraySelect
                            fullWidth
                            defaultOptionText={'Select status'}
                            onChange={(e) => {
                              setDateFilter({ ...dateFilter, status: e.target.value })
                            }}
                            withBorder
                            value={dateFilter?.status}
                            options={options}
                            labelKey={'label'}
                            valueKey={'value'}
                            defaultOption={true}
                          />
                        </Col>
                        <Col lg={2} className={'p-2'}>
                          <CalendarFilter filterByDate={(data) => {
                            setDateFilter({ ...dateFilter, ...data })
                          }} />
                        </Col>
                        <Col lg={2} className={'p-2'}>
                          <ButtonContainer disabled={loadingDocuments} onClick={() => !loadingDocuments && filterSearch()}>
                            Search
                          </ButtonContainer>
                        </Col>
                      </Row>
                    </CardHeader>
                    <CardBody>
                      <Row>
                        <Col lg={3}>
                          {
                            users.length > 0 &&
                            <table className={'table table-bordered'}>
                              <thead>
                                <tr className={'reports-table-header'}>
                                  <th className={'header-text'} >
                                    Users
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {users.map((item, index) => {
                                  return <tr key={'tr_' + index} className={`multicolor ${index === selectedGmailUserIndex && 'even'}`}>
                                    <td onClick={() => selectGmailUser(index)} className={'cursor-pointer'} key={index}>
                                      {item}
                                    </td>
                                  </tr>
                                })}
                              </tbody>

                            </table>
                          }

                        </Col>
                        <Col lg={9}>
                          {fullMailData ? <Container>
                            <Row>
                              <Col className={'p-3'}>
                                <h2>
                                  Gmail
                                </h2>
                              </Col>
                              <Col className={'p-3'}>
                                <ButtonContainer reverse onClick={() => setFullMailData(null)}>Back to the list</ButtonContainer>
                              </Col>

                            </Row>
                            <Card>
                              <CardBody>
                                <CardTitle>
                                  From - {fullMailData.from}
                                </CardTitle>
                                <CardSubtitle>
                                  {fullMailData.subject}
                                </CardSubtitle>
                                <CardText>
                                  {fullMailData.text}
                                </CardText>
                              </CardBody>
                            </Card>
                          </Container> :
                            <EmailsTable loading={loadingDocuments}
                              searchValue={dateFilter?.search}
                              nextPageToken={emailsNextPageToken}
                              paginate={getGmailOtherPages}
                              goToDetails={getMailsDetails}
                              tableData={emails}
                              keys={emailKeys} />
                          }

                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                }

              </Card>
            </Col>
          </Row>
        </Container>
      </>
  )
}